//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'arrival',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      order:{
        factory:[],
        community:{}
      },
      submitStatus:false,
    }
  },
  created(){
    this.config();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr;
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('订单号无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.getFactoryOrder({order_no:this.code,status:6}).then((res)=>{
        if(res){
          that.order = res.data;
          that.submitStatus = true;
          that.$func.endLoading();
        } 
      })  
    },
    submitFactory(){
      let that = this;
      if(!this.order.order_no){
        that.$func.showToast('订单号无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      this.$api.submitFactory({order_no:this.order.order_no,status:7}).then((res)=>{
        if(res){
          that.submitStatus = false;
          that.$func.showToast('到站成功');
          that.code = '';
          that.order = {
            factory:[],
            community:{}
          };

          wx.ready(function () {
              let media = document.getElementById("musicBox");
              media.src = "https://fcwash.uunbiot.com/uploads/default/arrival.mp3"
              media.play();
          });
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/arrival.vue